var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLateral01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 568 521",
    style: {
      enableBackground: "new 0 0 568 521"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#474747;}\r\n\t.st1{fill:#343434;}\r\n\t.st2{fill:#FFA8A7;}\r\n\t.st3{fill:#37474F;}\r\n\t.st4{fill:#263238;}\r\n\t.st5{fill:#455A64;}\r\n\t.st6{fill:#F28F8F;}\r\n\t.st7{fill:#B16668;}\r\n\t.st8{fill:#5757FF;}\r\n\t.st9{opacity:0.6;}\r\n\t.st10{fill:#FFFFFF;}\r\n\t.st11{opacity:0.15;enable-background:new    ;}\r\n\t.st12{opacity:0.3;enable-background:new    ;}\r\n\t.st13{fill:#FAFAFA;}\r\n\t.st14{opacity:0.1;}\r\n\t.st15{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st16{fill:#F0F0F0;}\r\n\t.st17{fill:#E0E0E0;}\r\n\t.st18{opacity:0.35;enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_401_Error_Unauthorized-amico",
    transform: "translate(-12.04 -23.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-2-2",
    className: "st0",
    cx: 296,
    cy: 376.7,
    rx: 238,
    ry: 135.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58",
    transform: "translate(86.562 23.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57",
    transform: "translate(0 269.894)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-2",
    className: "st1",
    cx: 110.1,
    cy: 69.3,
    rx: 64,
    ry: 37
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2-2",
    className: "st1",
    d: "M133.7,98.8l75.2-43.4c0.5-0.2,0.7-0.8,0.5-1.3c-0.1-0.2-0.3-0.4-0.5-0.5 l-5.8-3.4c-1-0.5-2.2-0.5-3.2,0l-75.2,43.4c-0.5,0.2-0.7,0.8-0.5,1.3c0.1,0.2,0.3,0.4,0.5,0.5l5.8,3.4 C131.5,99.3,132.7,99.3,133.7,98.8L133.7,98.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    transform: "translate(11.946 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2-3",
    transform: "translate(0 22.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-2",
    transform: "translate(58.345 57.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_631",
    className: "st2",
    d: "M68,50.7c4.5,10.1,8.3,20.9,11.7,25.3c6.8,4.2,24.1,12.8,30.6,14.4 c1.1,0.3,2.4,0.1,3.4-0.4c2.8-1.4,4.9-1.4,7.7-2.1c2.2-0.5,3.3-1.4,3.6-1s0.8,1.8-0.7,3.1c-1.1,0.9-2.4,1.7-3.6,2.4 c2.9,1.1,5.9,1.5,9,1.2c5.9-0.9,8.3,2.2,3.7,8c-1.6,2.1-7.5,5-18.5,2.8c-3.9-0.7-7.8-1.6-11.6-2.7c-10.4-3.5-22-7-29-10 c-2.6-1.3-4.9-3.3-6.5-5.7C60.2,73.1,54.3,63.6,50,54l0.6-20.6C61.5,32.9,64.2,42.2,68,50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_632",
    className: "st3",
    d: "M80,75.7c0,0-10.7-27.5-16.1-36.5c-3.7-6.3-8.2-6.8-15.9-6.9c-5,8.2,1.4,22.2,1.4,22.2 s9,18.4,15.5,29.3c4.2,7.1,5.5,7.6,11.6,10s18.8,7.2,18.8,7.2c-0.6-4.9,1.4-11.9,4.7-14.9L80,75.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_633",
    className: "st4",
    d: "M90.8,333.9c-0.1,1.3-0.3,5-7,5.9s-10.9-1.3-12.6-4.5s-1.4-5.8-1.6-8.8s-2.7-4.5-3.5-6.1 c-1-2.3,0.5-5.8,0.5-5.8L90.8,333.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_634",
    className: "st4",
    d: "M139.4,312.4c0.3,1.1,0.2,2.3-0.4,3.2c-3,2.4-6.9,3.4-10.6,2.9 c-4.1-0.6-7.9-2.1-11.3-4.4c-2.6-1.7-5.6-2.6-8.7-2.5c-3.2-0.1-5.5-0.8-5.8-1.7c-0.4-1.5-0.4-2.4,0.3-2.4L139.4,312.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_635",
    className: "st2",
    d: "M68.1,309.5c0.8,6.1,12.6,5.6,11.7,0.7l2.1-14.8l-13.3,0.4L68.1,309.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_636",
    className: "st3",
    d: "M90.3,330.8c-1-1.3-2-2.5-3.1-3.7c-4-5.1-6.4-11.2-6.9-17.7c0-0.4-0.1-1-0.4-1.3 s-0.7,0.1-1.1,0.3l0,0c-0.7,0.3-1.4,0.5-2.1,0.5c-2.4,0.3-5-0.3-5.6-0.2s-0.6,1.5-0.6,3c-0.8-0.5-1.1-1.6-1.9-2.2 c-0.4-0.3-0.6-0.4-0.6-0.9v-1c-0.6-0.2-1.1,2.1-1.6,3.9c-0.6,2.1-1.3,4.4-0.5,6.5c0.5,1.1,1.1,2.2,1.9,3.2 c1.3,1.7,2.1,3.7,2.4,5.9c0.1,0.9,0,1.9,0.1,2.8c0.4,3.2,2.7,5.9,5.8,6.8c4.1,1.3,10.2,1.1,13.8-1.8 C91.3,334,90.9,331.9,90.3,330.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_637",
    className: "st2",
    d: "M105.5,297.4c3.2,2.5,7.1,4,11.1,2.2l0.9-24.8l-13.4,2.4L105.5,297.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_638",
    className: "st3",
    d: "M136.7,308.1c-0.9-0.3-1.8-0.6-2.6-0.9c-2.4-1-4.8-2.1-7-3.5c-1-0.6-2-1.2-2.9-1.9 s-1.9-1.5-2.9-2.2c-0.5-0.4-0.9-0.9-1.4-1.5c-0.8-1-1.5-2.1-2-3.2c-0.1-0.3-0.3-0.5-0.5-0.7c-0.3-0.1-0.7,0-0.9,0.2 c-0.2,0.2-0.5,0.4-0.7,0.5l-0.8,0.3c-0.8,0.4-1.7,0.6-2.6,0.6c-3.4,0.3-3.5-0.4-3.6,0.7c0,0.4,0,0.8,0,1.2 c-1.8-0.3-3.2-0.9-3.3-1.6l-0.2-2.2c-1.8-0.2-1.9,3-2.5,6.6c-0.5,2.9-1.2,5-0.4,7.1c2.7,2.4,7.4,1.8,10.1,2.2 c3.8,0.6,5.6,3.5,10.9,5.3c8.6,3,14-0.5,15.6-2C140.1,311.5,140.3,309.3,136.7,308.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_639",
    className: "st4",
    d: "M71.8,152.4c-0.7,10.5-1.9,26-2.4,38.1C68.7,213.4,69,245,69,245 c-1.3,4.8-2.1,9.7-2.5,14.7c-0.5,14.6-0.5,51.1-0.5,51.1s6.1,6.1,15.1,1.3c0,0,8-49.7,10.3-64.1c2.1-13.7,6.3-46.7,6.3-46.7 l1.9,32.6c0,0-2.2,12.5-1.4,23.4c0.5,6.7,4.3,39.8,4.3,39.8c3.5,3.3,13.6,1.5,15.9-1.1c0,0,3.6-53.5,4-60.5 c0.9-15.3,3.1-65.7,2-74.6S71.8,152.4,71.8,152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_640",
    d: "M97.8,201.3l2.7-17.6c0,0,7.3-1.4,12.6-5.4c0,0-2.1,4.7-10.2,8.1l-2.6,16.4l-0.6,31.1L97.8,201.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_641",
    className: "st5",
    d: "M126.2,163.9c-0.7-23-0.7-29.2-2.8-45.9s-5.4-21.3-9.2-24.1c-2.5-1.8-14.3-6.6-14.3-6.6 v4.2c-8.1-0.8-17-5.9-17-5.9l-3.7,0.8C71,90.6,59.4,94.5,58,96.7c0,0,3.6,17.7,6.5,25.9c3,8.6,5.6,28.9,5.6,28.9 c-4,17.9-4.1,24.2-5,37.9c-0.7,11-0.5,27.7-0.5,27.7s12.4,5.7,33.2,5s29.2-4.7,29.2-4.7S126.9,186.1,126.2,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_642",
    className: "st3",
    d: "M112.5,119c0,0,3.5,9.9,4.9,35.3c1.1,20.6,0.8,53.7,0.6,65.6c-0.9,0.2-1.8,0.4-2.8,0.5 C115.9,201.6,117.7,139.5,112.5,119z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_6",
    className: "st3",
    cx: 110.8,
    cy: 140.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_7",
    className: "st3",
    cx: 100.6,
    cy: 140.8,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_8",
    className: "st3",
    cx: 111.3,
    cy: 152.9,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_643",
    className: "st3",
    d: "M99.2,153.4c0,1,0.8,1.8,1.9,1.8s1.9-0.8,1.9-1.9c0-1-0.8-1.8-1.9-1.8 S99.2,152.3,99.2,153.4L99.2,153.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_9",
    className: "st3",
    cx: 111.7,
    cy: 165.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_644",
    className: "st3",
    d: "M99.6,165.9c0,1,0.8,1.9,1.9,1.9c1,0,1.9-0.8,1.9-1.9c0-1-0.8-1.9-1.9-1.9c0,0,0,0,0,0 C100.4,164,99.6,164.9,99.6,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_645",
    className: "st4",
    d: "M109,106.4c-1.6-3.8,1.6-13.9,5.6-20.8c3-5.1,5.3-10.5,6.9-16.2c0,0-9.5-1.4-19.8-3.8 s-32.4-6.1-30.7,0s11,16.8,18.9,22S109,106.4,109,106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_646",
    className: "st4",
    d: "M80.5,44.7c-0.2,0-0.4,0.1-0.6,0.1c0.3-1.3-0.3-2.6-1.5-3.2c-1.6-0.6-3.3,0.1-4,1.6 l4.3,2c-1.4,0.5-2.6,1.5-3.3,2.8c-1.2,2.4,0.4,7.7,2,14.1c0.9,4,2.1,8,3.5,11.9c0.7,1.9,2,1.9,2,1.9v-6.4l2.4-7.1 c0.5-2.2,0.9-4.5,1.1-6.7c0.5-4.9-0.5-6.9-0.5-6.9L80.5,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_647",
    className: "st4",
    d: "M104.1,39.2c-6,0-10.8,4.9-10.8,10.9c0,6,4.9,10.8,10.9,10.8c6,0,10.8-4.9,10.8-10.9 c0,0,0,0,0,0C115,44,110.1,39.2,104.1,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_648",
    className: "st2",
    d: "M83.7,63.2c-1.3,1.1-2.5-2-3.8-2.9c-1.4-1.1-4.8-1.6-5.8,1.7c-1.2,3.7,1.6,7.1,3.7,8.1 c1.6,1,3.8,0.8,5.1-0.5v16c3.9,2.9,16.4,8.4,20.5,9.4c-0.9-2.5-2.1-4.9-3.5-7.2v-6.6c1.7,0.3,3.5,0.4,5.3,0.3 c3.5-0.6,5.4-3.4,6.4-7.2c1.7-6.1,2-16.3-0.3-28.2c-3.9-3-17.2-2.5-25.4,2.7C86.5,59.3,85,62.1,83.7,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_649",
    className: "st6",
    d: "M99.9,81.3c0,0-7.8-1.6-10.6-3c-1.6-0.8-2.9-2.1-3.8-3.7c0.4,1.6,1.2,3.1,2.2,4.4 c2,2.6,12.2,4.4,12.2,4.4L99.9,81.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_650",
    className: "st4",
    d: "M116.7,57.1c-0.1,0.6-0.3,1.2-0.7,1.7c-0.1,0.2-0.2,0.4-0.3,0.6c-0.2,1.5-0.5,3-1,4.5 c-0.7,2-2.6,3.3-4.8,3.3c-0.6,0-1.1,0-1.6-0.1c0,0-0.1,0-0.1,0c-0.5-0.1-0.9-0.3-1.4-0.5c0,0-0.1,0-0.1-0.1l-0.1-0.1l-0.1-0.1 c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1L106,66c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.5-0.8-1.1-1.1-1.7 c-0.7-1.6-0.6-3.8-1.7-4h-0.3c-1.6,0.1-1.4,2.4-2.2,4.2c-1,2.2-3.2,3.7-5.7,3.6H94c-0.3,0-0.5,0-0.8-0.1l-0.3-0.1 c-0.1,0-0.2,0-0.2-0.1h-0.2c-0.3-0.1-0.6-0.2-0.9-0.4c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.4-0.3-0.5-0.5 c-0.5-0.5-0.8-1-1.1-1.6c-0.5-1.4-0.8-2.9-1-4.4c0-0.2-0.1-0.5-0.3-0.7c-0.4-0.4-0.7-1-0.8-1.6c-0.1-0.6,0.3-1.2,0.9-1.4 l0.8-0.1c2.7-0.4,6.2-0.6,8.3-0.1c2.6,0.7,3.6,1.5,5,1.4s2.2-1,4.7-1.8c2.5-0.6,5.1-0.8,7.7-0.5c0.3,0,0.5,0,0.8,0.1 C116.3,55.7,116.7,56.4,116.7,57.1z M99.5,59.1c-0.2-0.2-0.5-0.4-0.8-0.6c0,0-0.1-0.1-0.1-0.1h-0.1l-0.4-0.2l-0.3-0.1 c-0.4-0.1-0.7-0.2-1.1-0.3c-0.1,0-0.3-0.1-0.5-0.1c-0.4-0.1-0.8-0.1-1.1-0.2h-0.3c-2.5-0.2-4.1,0.5-4.6,1s-0.3,2.9,0,4v0.1 c0,0,0,0.1,0,0.1c0,0.2,0.1,0.3,0.1,0.5c0,0.2,0,0.2,0.1,0.3l0,0c0.1,0.2,0.1,0.3,0.2,0.5c0,0.1,0,0.1,0.1,0.2c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1l0.1,0.1l0.1,0.2c0,0.1,0.1,0.1,0.1,0.2l0.1,0.2c0.8,1.1,2.2,1.7,3.6,1.6c1.4,0,2.7-0.5,3.7-1.5 c0.6-0.7,1-1.5,1.2-2.4C99.8,61.3,100,59.8,99.5,59.1L99.5,59.1z M114.3,57.5c-0.2-0.2-0.4-0.3-0.6-0.4c0,0,0,0,0,0l-0.3-0.1 h-0.3c0,0-0.1,0-0.1,0h-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.1,0-0.2,0-0.3,0h-1c-0.4,0-0.8,0.1-1.2,0.1c-1.8,0.3-3.6,1.2-4.1,1.9 s-0.3,2.3-0.1,3.6c0.1,0.3,0.1,0.6,0.2,0.9c0,0,0,0,0,0.1v0.3c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2l0.1,0.1 c0,0,0,0.1,0.1,0.1l0,0c0.9,1.2,2.3,1.8,3.8,1.6c0.7,0,1.3-0.2,1.9-0.5c1.8-0.9,2.2-3,2.4-3.9C114.5,60.4,114.8,58,114.3,57.5 L114.3,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_651",
    className: "st4",
    d: "M88.7,56.8l-11.6,2.7c1.3-0.1,2.6,0.5,3.4,1.4l8.2-1.6L88.7,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_652",
    className: "st3",
    d: "M114.3,61.6c-0.2,0.9-0.6,2.9-2.4,3.9c-0.6,0.3-1.2,0.5-1.9,0.5 c-1.5,0.2-2.9-0.4-3.8-1.6l0,0c0,0,0-0.1-0.1-0.1l-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2v-0.3c0,0,0,0,0-0.1 c-0.1-0.3-0.2-0.6-0.2-0.9c-0.3-1.3-0.4-2.8,0.1-3.6s2.3-1.6,4.1-1.9c0.4-0.1,0.8-0.1,1.2-0.1h1c0.1,0,0.2,0,0.3,0 c0.2,0,0.4,0,0.6,0.1h0.1c0,0,0.1,0,0.1,0h0.3l0.3,0.1c0,0,0,0,0,0c0.2,0.1,0.4,0.2,0.6,0.4C114.8,58,114.5,60.4,114.3,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_653",
    className: "st3",
    d: "M99.6,62.6c-0.2,0.9-0.6,1.7-1.2,2.4c-1,1-2.3,1.5-3.7,1.5c-1.4,0.1-2.7-0.5-3.6-1.6 L91,64.8c0-0.1-0.1-0.1-0.1-0.2l-0.1-0.2l-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1-0.1-0.1-0.1-0.2 c-0.1-0.2-0.1-0.3-0.2-0.5l0,0c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.3-0.1-0.5c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c-0.3-1.2-0.6-3.5,0-4c1.4-0.9,3-1.2,4.6-1h0.3c0.4,0,0.8,0.1,1.1,0.2c0.2,0,0.3,0.1,0.5,0.1c0.4,0.1,0.8,0.2,1.1,0.3l0.3,0.1 l0.4,0.2h0.1c0.1,0,0.1,0,0.1,0.1c0.3,0.1,0.5,0.3,0.8,0.6C100,59.8,99.8,61.3,99.6,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_654",
    className: "st4",
    d: "M114,37.8c0-0.1,0-0.3,0-0.4c0-0.2-0.1-0.5-0.3-0.7c-0.5-0.6-1.6,0.8-2,1.2 c-0.4,0.3-0.7,0.6-1.1,0.9c-0.4,0.2-0.7,0.4-1,0.6c0.2-1.3,0.2-2.6,0-3.9c-0.2-0.9-0.4-2.9-1.5-3.1c-0.6-0.1-1.2,0.4-1.7,0.8 c-4.3,4-9.9,2.2-15,2.3c-4.3,0.1-9.5,1.9-11.5,6.1c-0.9,1.9-1,3.9,0.7,5.3c1.1,0.9,2.2,0.8,2.9,2.2c0.1,0.3,1.1,4.4,0.6,4.4 c2.2,0.2,4.2-1.2,4.8-3.3c0.1-0.4,0.4-1.3,0.5-1.7c0.1-0.5,0.7-0.9,1.2-0.8c0,0,0,0,0,0c1.3,0.3,2.2,0.8,3.4,1.2 c3.5,1,7.2,1.2,10.9,0.6c2.6-0.5,5-1.8,6.8-3.7C113.6,43.6,114.4,40.7,114,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_655",
    className: "st4",
    d: "M97.1,54.6l-3.8,0.6c-0.1-1.1,0.6-2.1,1.6-2.2C96,52.8,97,53.5,97.1,54.6 C97.1,54.6,97.1,54.6,97.1,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_656",
    className: "st4",
    d: "M111.5,54.9l-3.8-0.4c0.1-1,0.9-1.8,2-1.7c0,0,0.1,0,0.1,0 C110.8,52.8,111.6,53.8,111.5,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_657",
    className: "st6",
    d: "M102.2,60.1l0.5,8.9l5-1.3l-5-7.7C102.5,60,102.3,60.1,102.2,60.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_10",
    className: "st7",
    cx: 99.8,
    cy: 72.4,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_658",
    className: "st3",
    d: "M112.5,119c-1.4-10-8.6-24.5-12.2-28.5c-4.4-4.9-8.7-12.8-9-16.6c0,0-14.8,1.1-20.4-8.3 c0.7,7.6,3.6,14.8,8.4,20.8c0,0,14.6,5.3,20,10.4C106.7,103.7,112.5,119,112.5,119z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_659",
    className: "st2",
    d: "M47.3,139.5c5.7-31.2,3.8-38.7,11.4-43.7c2.4-1.4,4.9-2.6,7.5-3.5 c2.8,3.3,6.4,11,2.3,22.3c0,0-4,17.6-6,26.6c2.5,7.8,6.3,17.2,10,22.2c0.8,1,1.9,1.7,3.1,1.9l3.9,7c0.5,0.5,1.1,1.1,1.6,1.5 c-0.7,4.6-3.7,8.5-7.9,10.3c-2.5-1.6-4.8-3.6-6.8-5.8c-2.5-3.5-4.8-7.1-6.9-10.9c-3.8-6.8-8.1-14-10.6-19.8 C47.2,143.4,46.9,141.6,47.3,139.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_660",
    className: "st3",
    d: "M81.5,162.7c0,7-3,18.1-13.5,20.9v3.8c0,0,8-0.8,12.3-6.6s5.4-11.4,5.4-18.1L81.5,162.7z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_661",
    className: "st2",
    d: "M83,168.6c-2.8-1.2-4-2.8-7.4-3.4l3.9,7c1.3,0.3,2.7,0.4,4,0.4c1.5,0,2.9-1.1,3.2-2.6 C86.8,169.4,85.3,169.6,83,168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_662",
    className: "st3",
    d: "M68.6,91.2c-6.6,1.6-11.3,3.7-13.4,5.3s-4.1,10.5-5,16.2s-4.1,27-4.2,29.4 s12.8,26.7,12.8,26.7s4.9-6.6,12.2-8.8l-7.3-19.4l7.7-27.8C71.5,112.9,75.8,103.9,68.6,91.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--exclamation-marks--inject-2",
    transform: "translate(74.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_663",
    className: "st8",
    d: "M53.4,53.8c0.2-0.5-0.1-1.1-0.6-1.2l-4.4-1.3c-0.5-0.1-1,0.1-1.2,0.7l-1.1,3.5 c-0.1,0.2,0,0.5,0.1,0.7c0.1,0.2,0.3,0.4,0.6,0.5l4.4,1.3c0.5,0.1,1-0.1,1.2-0.7L53.4,53.8z M59.1,34.9 c0.1-0.5-0.1-1.1-0.6-1.2l-4.4-1.3c-0.2-0.1-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.3-0.5,0.6L48.3,48c-0.1,0.5,0.1,1,0.6,1.2l4.4,1.3 c0.2,0.1,0.5,0,0.7-0.1c0.2-0.1,0.4-0.3,0.5-0.6L59.1,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_664",
    className: "st8",
    d: "M59.3,69.4c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.2-0.7l-3.1-3.4 c-0.4-0.4-1-0.4-1.4-0.1l-2.7,2.5c-0.2,0.2-0.3,0.5-0.3,0.7c0,0.3,0.1,0.5,0.2,0.7l3,3.3c0.4,0.4,1,0.4,1.4,0.1L59.3,69.4z  M73.9,56.2c0.4-0.4,0.4-1,0-1.4l-3-3.4c-0.4-0.4-1-0.4-1.4-0.1L57.9,61.8c-0.4,0.4-0.4,1-0.1,1.4l3.1,3.4 c0.4,0.4,1,0.4,1.4,0.1L73.9,56.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_55",
    transform: "translate(5.841 18.764)",
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_665",
    className: "st10",
    d: "M53.4,50.7c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.2-0.7l-3.1-3.4 c-0.4-0.4-1-0.4-1.4-0.1l-2.7,2.5C46.1,48.5,46,48.8,46,49c0,0.3,0.1,0.5,0.2,0.7l3,3.3c0.4,0.4,1,0.4,1.4,0.1L53.4,50.7z  M68,37.4c0.4-0.4,0.4-1,0-1.4l-3-3.4c-0.4-0.4-1-0.4-1.4-0.1L52,43c-0.4,0.4-0.4,1-0.1,1.4l3.1,3.4c0.4,0.4,1,0.4,1.4,0.1 L68,37.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--id-card--inject-2",
    transform: "translate(83.61 135.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--id-card--inject-2-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666",
    className: "st8",
    d: "M50,70.7l65.5-37.8c0.8-0.6,1.8-0.7,2.7-0.3c0.7,0.4,3,1.7,4.2,2.4l0.2,0.1 c0.2,0.1,0.3,0.2,0.5,0.4c0.1,0.1,0.3,0.3,0.4,0.5c0,0.1,0,0.1,0.1,0.2c0,0.2,0.1,0.3,0.1,0.5c0.1,0.3,0.1,0.7,0.1,1V181 c-0.1,2.7-1.6,5.3-3.9,6.7l-65.5,37.9c-0.4,0.2-0.9,0.4-1.3,0.5c-0.4,0.1-0.9,0-1.3-0.1c-0.1,0-0.1,0-0.2-0.1l-4.3-2.5 c-0.8-0.6-1.3-1.5-1.1-2.5V77.5C46.2,74.7,47.7,72.2,50,70.7z M78.8,77.1l16.6-9.6c2.7-1.7,4.4-4.5,4.6-7.6 c0-2.7-2.1-3.8-4.6-2.3l-1.9,1.1l-14.7,8.5c-2,1.2-3.5,3.2-4.2,5.4c-0.3,0.7-0.4,1.5-0.4,2.3C74.2,77.6,76.3,78.6,78.8,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_667",
    className: "st11",
    d: "M50,70.7l65.5-37.8c0.8-0.6,1.8-0.7,2.7-0.3c0.7,0.4,3,1.7,4.2,2.4l0.2,0.1 c0.2,0.1,0.3,0.2,0.5,0.4c0.1,0.1,0.3,0.3,0.4,0.5c0,0.1,0,0.1,0.1,0.2c0,0.2,0.1,0.3,0.1,0.5c0.1,0.3,0.1,0.7,0.1,1V181 c-0.1,2.7-1.6,5.3-3.9,6.7l-65.5,37.9c-0.4,0.2-0.9,0.4-1.3,0.5c-0.4,0.1-0.9,0-1.3-0.1c-0.1,0-0.1,0-0.2-0.1l-4.3-2.5 c-0.8-0.6-1.3-1.5-1.1-2.5V77.5C46.2,74.7,47.7,72.2,50,70.7z M78.8,77.1l16.6-9.6c2.7-1.7,4.4-4.5,4.6-7.6 c0-2.7-2.1-3.8-4.6-2.3l-1.9,1.1l-14.7,8.5c-2,1.2-3.5,3.2-4.2,5.4c-0.3,0.7-0.4,1.5-0.4,2.3C74.2,77.6,76.3,78.6,78.8,77.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_668",
    className: "st8",
    d: "M51.7,225.9c-0.1,0-0.1,0-0.2-0.1l-4.3-2.5c-0.8-0.6-1.3-1.5-1.2-2.5V77.5 c0-1.4,0.4-2.7,1.2-3.9l4.4,2.5c-0.7,1.2-1.1,2.5-1.2,3.9v143.3C50.3,224.3,50.8,225.3,51.7,225.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_669",
    className: "st12",
    d: "M51.7,225.9c-0.1,0-0.1,0-0.2-0.1l-4.3-2.5c-0.8-0.6-1.3-1.5-1.2-2.5V77.5 c0-1.4,0.4-2.7,1.2-3.9l4.4,2.5c-0.7,1.2-1.1,2.5-1.2,3.9v143.3C50.3,224.3,50.8,225.3,51.7,225.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_670",
    className: "st8",
    d: "M54.3,73.2l18.4-10.6L89.4,53l30.5-17.6c0.7-0.5,1.7-0.7,2.6-0.4l0.2,0.1 c0.2,0.1,0.3,0.2,0.5,0.4c0.1,0.1,0.3,0.3,0.4,0.5c0,0.1,0,0.1,0.1,0.2c0,0.2,0.1,0.3,0.1,0.5c0.1,0.3,0.1,0.7,0.1,1V181 c-0.1,2.7-1.6,5.3-3.9,6.7l-65.5,37.9c-0.4,0.2-0.9,0.4-1.3,0.5c-0.4,0.1-0.9,0-1.3-0.1c-0.9-0.5-1.4-1.6-1.3-2.6V80 C50.6,77.2,52,74.7,54.3,73.2z M78.8,77.2l16.6-9.6c2.7-1.7,4.4-4.5,4.6-7.6c0-2.7-2.1-3.8-4.6-2.3l-1.9,1.1l-14.7,8.5 c-2,1.2-3.5,3.1-4.2,5.4c-0.3,0.7-0.4,1.5-0.4,2.3C74.2,77.6,76.3,78.6,78.8,77.2L78.8,77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_671",
    className: "st13",
    d: "M63.8,93l46.6-26.9c0.8-0.5,1.5-0.1,1.5,0.9v71.9c-0.1,1.1-0.6,2-1.5,2.6l-46.6,26.9 c-0.8,0.5-1.5,0.1-1.5-0.9V95.6C62.3,94.5,62.9,93.5,63.8,93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_672",
    className: "st5",
    d: "M77.3,102.9l19.5-11.3c-0.7-2.3-2-7.9-3.9-9.5s-3.7,3.6-5.9,4.9s-4.2-1.5-5.9,1.9 C79.4,92.6,78,99.8,77.3,102.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_673",
    className: "st5",
    d: "M75,109.3l24.1-13.9c0.7-0.5,1.1-1.2,1.1-2.1v-0.9c0-0.8-0.5-1.2-1.1-0.8L75,105.5 c-0.7,0.5-1.1,1.3-1.1,2.1v0.9C74,109.3,74.4,109.7,75,109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_674",
    className: "st5",
    d: "M77.2,110l9.3-5.4l0.5-0.3l9.9-5.7c0.6-0.4,1.1,0,1.1,0.8v1.4c-0.1,0.8-0.5,1.6-1.1,2.2 c-0.6,0.8-2.7,3.6-4.4,4.8c-0.6,0.4-1.3,0.6-2.1,0.7l-2.4-0.1c-0.4,0-0.7,0.1-1,0.3l0,0c-0.4,0.2-0.7,0.5-1,0.8l-2.4,2.9 c-1.5,2-4.1,2.8-6.5,2c-0.6-0.1-1.1-0.2-1.1-1v-1.4C76.1,111.2,76.5,110.4,77.2,110L77.2,110z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_675",
    className: "st8",
    d: "M80.6,109.6c-0.1,1.5,0.7,2.3,1.8,1.9c1.3-0.7,2.2-2,2.3-3.5L80.6,109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_676",
    className: "st8",
    d: "M93.6,102c0,1.5-0.6,3-1.8,4c-1.1,0.8-2.1,0.5-2.3-0.8L93.6,102z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_677",
    className: "st5",
    d: "M75.8,131.5l-8.4-2.4c1.9-3.4,9.6-13.7,9.6-13.7c1.3,10.2,6.1,10.1,10,7.8 s8.8-7.7,10-19.4c0,0,7.7,1.4,9.6,2.7l-8.4,12.1c0,0,4.3-0.9,5.2,1s2.4,24.5,2.4,24.5L87,154.8l-18.8,10.8 c0,0,1.5-24.3,2.4-27.2S75.8,131.5,75.8,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_678",
    className: "st5",
    d: "M71.7,170l30.7-17.7c1.1-0.6,2-0.1,2,1.2v0.8c-0.1,1.4-0.8,2.7-2,3.5l-30.7,17.7 c-1.1,0.6-2,0.1-2-1.2v-0.8C69.8,172.1,70.5,170.8,71.7,170z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_679",
    className: "st5",
    d: "M64.2,189.6l11-6.4c0.5-0.3,0.8-0.1,0.8,0.4c0,0.6-0.4,1.1-0.8,1.4l-11,6.3 c-0.5,0.3-0.9,0.1-0.9-0.4C63.4,190.4,63.7,189.9,64.2,189.6L64.2,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_680",
    className: "st5",
    d: "M83.2,178.7l26.8-15.4c0.5-0.3,0.8-0.1,0.8,0.4c0,0.6-0.4,1.1-0.8,1.4l-26.8,15.4 c-0.5,0.3-0.8,0.1-0.8-0.4C82.4,179.5,82.7,179,83.2,178.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_681",
    className: "st5",
    d: "M64.2,193.2l11-6.3c0.5-0.3,0.8-0.1,0.8,0.4c0,0.6-0.4,1.1-0.8,1.4l-11,6.3 c-0.5,0.3-0.9,0.1-0.9-0.4C63.5,194.1,63.7,193.6,64.2,193.2L64.2,193.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_682",
    className: "st5",
    d: "M83.2,182.3l26.8-15.4c0.5-0.3,0.8-0.1,0.8,0.4c0,0.6-0.4,1.1-0.8,1.4l-26.8,15.4 c-0.5,0.3-0.8,0.1-0.8-0.4C82.4,183.1,82.7,182.6,83.2,182.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_683",
    className: "st5",
    d: "M68.1,198.7v11.4l3.3-1.9v-11.4L68.1,198.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_684",
    className: "st5",
    d: "M78,193v11.4l3.3-1.9v-11.4L78,193z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_685",
    className: "st5",
    d: "M91.2,185.4v11.4l3.3-1.9v-11.4L91.2,185.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_686",
    className: "st5",
    d: "M102.7,178.7v11.4l3.3-1.9v-11.4L102.7,178.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_687",
    className: "st5",
    d: "M73.1,195.9v11.4l1.6-1v-11.4L73.1,195.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_688",
    className: "st5",
    d: "M96.1,182.5V194l1.6-1v-11.4L96.1,182.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_689",
    className: "st5",
    d: "M86.2,188.3v11.4l1.6-1v-11.4L86.2,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_690",
    className: "st5",
    d: "M76.4,194v11.4l0.8-0.5v-11.4L76.4,194z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_691",
    className: "st5",
    d: "M89,186.7v11.4l0.8-0.5v-11.4L89,186.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_692",
    className: "st5",
    d: "M83.8,189.7v11.4l0.8-0.5v-11.4L83.8,189.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_693",
    className: "st5",
    d: "M100.3,180.2v11.4l0.8-0.5v-11.4L100.3,180.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_694",
    className: "st5",
    d: "M82.1,190.6V202l0.8-0.5v-11.4L82.1,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_695",
    className: "st5",
    d: "M98.6,181.1v11.4l0.8-0.5v-11.4L98.6,181.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_696",
    className: "st12",
    d: "M73.6,177.5l26.8-15.4c0.5-0.3,0.9-0.1,0.9,0.4c0,0.6-0.4,1.1-0.9,1.4l-26.8,15.5 c-0.5,0.3-0.8,0.1-0.8-0.4C72.9,178.4,73.2,177.8,73.6,177.5L73.6,177.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_697",
    className: "st8",
    d: "M74.3,75.7c0.4,2,2.3,2.7,4.5,1.4l16.6-9.6c2.7-1.7,4.4-4.5,4.6-7.6 c0-2.3-1.5-3.4-3.5-2.8c0.1,0.3,0.1,0.6,0.1,0.9c-0.2,3.1-1.9,5.9-4.6,7.6l-16.6,9.6C75.1,75.5,74.7,75.6,74.3,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_698",
    className: "st11",
    d: "M74.3,75.7c0.4,2,2.3,2.7,4.5,1.4l16.6-9.6c2.7-1.7,4.4-4.5,4.6-7.6 c0-2.3-1.5-3.4-3.5-2.8c0.1,0.3,0.1,0.6,0.1,0.9c-0.2,3.1-1.9,5.9-4.6,7.6l-16.6,9.6C75.1,75.5,74.7,75.6,74.3,75.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56",
    transform: "translate(173 16.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2-3",
    className: "st1",
    d: "M100.8,443.2l27.9,16.1c4.8,2.4,10.5,2.4,15.3,0l161.1-93 c4.2-2.5,4.2-6.4,0-8.9l-27.9-16.1c-4.8-2.4-10.5-2.4-15.4,0l-161.1,93C96.6,436.8,96.6,440.8,100.8,443.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_534",
    className: "st8",
    d: "M116.6,432.2c0.4-11.5,0.8-22.8-4.7-39.3c-4.5-13.8-17.7-27.8-26.2-28.1 c-11.2-0.4-12.6,7.6-6.8,15.9c4.3,6.1,18.3,14.2,24.8,29.1c3.6,8.5,5.3,17.6,5.2,26.8L116.6,432.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_535",
    className: "st10",
    d: "M113.2,429.3c-0.2-0.1-0.4-0.3-0.4-0.5c0.6-25.9-13.9-48.7-27.2-56.5 c-0.2-0.1-0.3-0.4-0.2-0.7c0.1-0.2,0.4-0.3,0.7-0.2c13.1,7.1,27.8,30.1,27.7,57.3c0,0.3-0.2,0.5-0.5,0.5 C113.3,429.3,113.2,429.3,113.2,429.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_536",
    className: "st8",
    d: "M109.7,436.2c-1.6,1-3.7,0.4-4.7-1.2c-0.1-0.2-0.2-0.4-0.3-0.6 c-2.1-5.4-5.3-10.4-9.5-14.5c-7.3-7.3-17.4-12-19-16.9c-1.9-6,3.4-9,11.9-6.9c10.3,2.5,21.9,14.9,23.2,39.2L109.7,436.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_54",
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_537",
    d: "M109.7,436.2c-1.6,1-3.7,0.4-4.7-1.2c-0.1-0.2-0.2-0.4-0.3-0.6c-2.1-5.4-5.3-10.4-9.5-14.5 c-7.3-7.3-17.4-12-19-16.9c-1.9-6,3.4-9,11.9-6.9c10.3,2.5,21.9,14.9,23.2,39.2L109.7,436.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_538",
    className: "st10",
    d: "M109.6,434.6c-0.2,0-0.3-0.2-0.4-0.4c-3.4-21.3-18.8-31.6-25.7-33.9 c-0.3-0.1-0.4-0.4-0.3-0.6c0.1-0.3,0.4-0.4,0.6-0.3c0,0,0,0,0,0c7.6,2.5,22.8,13,26.4,34.7c0,0.3-0.1,0.5-0.4,0.6 C109.7,434.6,109.7,434.6,109.6,434.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--card-reader--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--card-reader--inject-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_539",
    className: "st5",
    d: "M145.5,450.8c-4.2,2.4-9.9,2.1-16.3-1.6L115,441c-2.3-1.5-3.7-3.9-3.9-6.6V251.9 c-0.1-1,0.3-1.9,1.1-2.5l151.3-87.3c0.9-0.4,1.9-0.3,2.7,0.3l14.2,8.2c12.7,7.4,23,25.2,23,39.9v138.1c0,7.4-2.6,12.5-6.8,14.9 L145.5,450.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_540",
    className: "st8",
    d: "M302.7,203.4c-2.6-12.9-11.6-26.6-22.3-32.9l-14.2-8.2c-0.8-0.6-1.8-0.7-2.7-0.3 l-151.3,87.3c-0.8,0.6-1.2,1.5-1.1,2.5v20.5l36,20.8L302.7,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_541",
    className: "st15",
    d: "M297.8,189.7l-165,95.3l-21.6-12.5v-20.5c-0.1-1,0.3-1.9,1.1-2.5l151.3-87.3 c0.9-0.4,1.9-0.3,2.7,0.3l14.2,8.2C287.3,174.6,293.5,181.6,297.8,189.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_542",
    className: "st8",
    d: "M303.5,348.6v-4.2l-156.3,90.2l-36-20.8v20.5c0.2,2.7,1.6,5.2,3.9,6.6l14.2,8.2 c6.4,3.7,12.1,4,16.3,1.6l151.2-87.3C300.9,361.1,303.5,355.9,303.5,348.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_543",
    className: "st4",
    d: "M163.5,294.8l57.4-33.1c1.1-0.6,1.9-0.1,1.9,1.1v45.5c-0.1,1.4-0.8,2.6-1.9,3.3 l-57.4,33.1c-1.1,0.6-1.9,0.1-1.9-1.1v-45.5C161.6,296.8,162.4,295.5,163.5,294.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_544",
    className: "st8",
    d: "M219,305.8v-43.1l-55.6,32.1c-1.1,0.7-1.8,2-1.9,3.3v43.1l55.6-32.1 C218.3,308.3,219,307.1,219,305.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_548",
    className: "st13",
    d: "M194.8,299.6c0-7,1.6-11.4,4.9-13.3s4.9,0.6,4.9,7.6c0,7-1.6,11.4-4.9,13.3 S194.8,306.6,194.8,299.6z M201.5,301.3c0.4-1.9,0.6-3.9,0.6-5.9c0.1-1.8-0.1-3.5-0.6-5.2c-0.1-0.6-0.7-1-1.3-0.8 c-0.2,0-0.3,0.1-0.5,0.2c-0.9,0.6-1.5,1.6-1.8,2.6c-0.4,1.9-0.6,3.9-0.6,5.9c-0.1,1.8,0.1,3.5,0.6,5.2c0.4,0.9,1,1.1,1.8,0.6 C200.6,303.3,201.2,302.4,201.5,301.3L201.5,301.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_699",
    className: "st13",
    d: "M184.4,305.6c0-7,1.6-11.4,4.9-13.3s4.9,0.6,4.9,7.6c0,7-1.6,11.4-4.9,13.3 S184.4,312.6,184.4,305.6z M191,307.3c0.4-1.9,0.6-3.9,0.6-5.9c0.1-1.8-0.1-3.5-0.6-5.2c-0.1-0.6-0.7-1-1.3-0.8 c-0.2,0-0.3,0.1-0.5,0.2c-0.9,0.6-1.5,1.6-1.8,2.6c-0.4,1.9-0.6,3.9-0.6,5.9c-0.1,1.8,0.1,3.5,0.6,5.2c0.4,0.9,1,1.1,1.8,0.6 C190.2,309.4,190.8,308.4,191,307.3L191,307.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_700",
    className: "st13",
    d: "M173.9,312c0-7,1.6-11.4,4.9-13.3s4.9,0.6,4.9,7.6c0,7-1.6,11.4-4.9,13.3 S174,319,173.9,312z M180.6,313.7c0.4-1.9,0.6-3.9,0.6-5.9c0.1-1.8-0.1-3.5-0.6-5.2c-0.1-0.6-0.7-1-1.3-0.8 c-0.2,0-0.3,0.1-0.5,0.2c-0.9,0.6-1.5,1.6-1.8,2.6c-0.4,1.9-0.6,3.9-0.6,5.9c-0.1,1.8,0.1,3.5,0.6,5.2c0.4,0.9,1,1.1,1.8,0.6 C179.8,315.7,180.4,314.8,180.6,313.7L180.6,313.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_550",
    className: "st16",
    d: "M173.6,348.6c-0.3-0.1-0.5-0.1-0.8,0.1l-9.8,5.7c-0.6,0.4-1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.6,0.3,0.7c0.2,0.1,1.7,1,1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9v-7.4 c0-0.3-0.1-0.6-0.3-0.7L173.6,348.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_551",
    className: "st17",
    d: "M162.3,364.3c0.2,0.1,1.7,1,1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.5-4.3l-10.1-5.8 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C161.9,363.8,162,364.1,162.3,364.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_552",
    className: "st13",
    d: "M163.8,357.3v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9v-7.4 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C164.3,355.8,163.9,356.5,163.8,357.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_553",
    className: "st5",
    d: "M168.6,356.9c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0.1-0.2l1.2-2.1l0.1-0.2 c0-0.1,0.1-0.1,0.1-0.1l0.7-0.4h0.1c0,0,0,0.1,0,0.1v5.4c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1l-0.7,0.4c0,0-0.1,0-0.1,0 c0,0,0,0,0,0v-3.8l-0.7,1.1c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0L168.6,356.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_554",
    className: "st16",
    d: "M189.8,339.2c-0.3-0.1-0.6-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1.1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.7-0.4,1.1-1.1,1.1-1.9V341c0-0.3-0.1-0.5-0.3-0.7 L189.8,339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_555",
    className: "st17",
    d: "M178.5,354.9l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.4-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C178.1,354.5,178.2,354.7,178.5,354.9L178.5,354.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_556",
    className: "st13",
    d: "M180,347.9v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.7-0.4,1.1-1.1,1.1-1.9V341 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C180.5,346.4,180.1,347.2,180,347.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_557",
    className: "st5",
    d: "M187.5,345.9c0,0.2,0,0.3,0,0.5c0,0.2-0.1,0.3-0.1,0.5c-0.1,0.2-0.1,0.4-0.2,0.5 c-0.1,0.2-0.2,0.4-0.3,0.6l-0.8,1.3l1.4-0.8c0,0,0.1,0,0.1,0v1c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1l-2.9,1.7 c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-0.7c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.3l1.6-2.8c0.1-0.2,0.2-0.3,0.2-0.5 c0-0.1,0-0.3,0.1-0.4c0,0,0-0.1,0-0.1c0-0.1,0-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.2,0.1-0.2,0.2 c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.2v0.2c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1l-0.7,0.4c0,0-0.1,0-0.1,0 c0,0,0-0.1,0-0.1c0-0.3,0-0.5,0.1-0.8c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.3,0.3-0.5,0.5-0.7c0.2-0.2,0.4-0.4,0.7-0.6 c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.3,0.5C187.6,345.5,187.6,345.7,187.5,345.9L187.5,345.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_558",
    className: "st16",
    d: "M206,329.9c-0.3-0.1-0.5-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9v-7.4c0-0.3-0.1-0.5-0.3-0.7L206,329.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_559",
    className: "st17",
    d: "M194.7,345.5l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.5-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C194.3,345.1,194.4,345.4,194.7,345.5L194.7,345.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_560",
    className: "st13",
    d: "M196.2,338.6v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9v-7.4 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C196.7,337.1,196.3,337.8,196.2,338.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_561",
    className: "st5",
    d: "M203.5,334.8c0,0,0.1,0,0.1,0v1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2l-0.7,1.4 c0.2-0.1,0.5,0,0.7,0.2c0.2,0.2,0.3,0.6,0.3,0.9c0,0.6-0.1,1.2-0.4,1.7c-0.3,0.5-0.7,0.9-1.2,1.2c-0.2,0.1-0.4,0.2-0.7,0.3 c-0.2,0-0.4,0-0.5-0.1c-0.1-0.1-0.3-0.2-0.3-0.4c-0.1-0.2-0.1-0.4-0.1-0.5c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1l0.7-0.4 c0.1,0,0.1,0,0.2,0l0.1,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.2-0.3,0.2-0.5 c0-0.2-0.1-0.3-0.2-0.3c-0.2,0-0.3,0-0.4,0.1l-0.4,0.3c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-0.7c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1,0.1-0.2l0.6-1.2l-1.4,0.8h-0.1c0,0-0.1-0.1-0.1-0.1v-0.9c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.1L203.5,334.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_562",
    className: "st16",
    d: "M222.2,320.5c-0.3-0.1-0.5-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1,1.1-1.1,1.9v7.3 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.9v-7.3c0-0.3-0.1-0.5-0.3-0.7 L222.2,320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_563",
    className: "st17",
    d: "M210.9,336.2l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.5-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.3C210.5,335.7,210.6,336,210.9,336.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_564",
    className: "st13",
    d: "M212.4,329.2v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.9v-7.3 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C212.9,327.8,212.5,328.5,212.4,329.2L212.4,329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_565",
    className: "st5",
    d: "M218.4,326.2c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1v0.9c0,0.1,0,0.1-0.1,0.2 c0,0.1-0.1,0.1-0.1,0.1l-1.6,1v1.1l1.5-0.9c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1v0.9c0,0.1,0,0.1,0,0.2 c0,0.1-0.1,0.1-0.1,0.1l-1.5,0.9v1.8c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1l-0.7,0.4c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1V328 c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1L218.4,326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_566",
    className: "st5",
    d: "M218.9,327.8c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.2l1.2-2.1c0-0.1,0.1-0.1,0.1-0.2 c0-0.1,0.1-0.1,0.1-0.1l0.7-0.4c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v5.5c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.1,0.1l-0.7,0.4 c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-3.7l-0.6,1.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0L218.9,327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_567",
    className: "st16",
    d: "M173.6,364.9c-0.3-0.1-0.5-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7c0.2,0.1,1.7,1,1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9v-7.4 c0-0.3-0.1-0.5-0.3-0.7L173.6,364.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_568",
    className: "st17",
    d: "M162.3,380.6c0.2,0.1,1.7,1,1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.5-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C161.9,380.1,162,380.4,162.3,380.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_569",
    className: "st13",
    d: "M163.8,373.6v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9v-7.4 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C164.3,372.1,163.9,372.8,163.8,373.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_570",
    className: "st5",
    d: "M170.1,376.4c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-0.9l-1.7,1c0,0-0.1,0-0.1,0 c0,0,0-0.1,0-0.1v-0.9c0-0.1,0-0.3,0.1-0.4l1.6-4.1c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.1-0.1l0.8-0.5h0.1c0,0,0,0.1,0,0.1v3.2 l0.5-0.3c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v0.9c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1l-0.5,0.3v0.9c0,0.1,0,0.1,0,0.2 c0,0.1-0.1,0.1-0.1,0.1L170.1,376.4z M170,374v-1.5l-0.8,2L170,374z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_571",
    className: "st16",
    d: "M189.8,355.5c-0.3-0.1-0.6-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1.1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.9v-7.3c0-0.3-0.1-0.5-0.3-0.7 L189.8,355.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_572",
    className: "st17",
    d: "M178.5,371.2l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.4-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C178.1,370.8,178.2,371,178.5,371.2L178.5,371.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_573",
    className: "st13",
    d: "M180,364.3v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.9v-7.3 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C180.5,362.8,180.1,363.5,180,364.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_574",
    className: "st5",
    d: "M185.4,365.7l0.1,0.1c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2-0.1 c0.1,0,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.4c0-0.1,0-0.3-0.1-0.4 c-0.1-0.1-0.2,0-0.4,0c-0.1,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1l-0.1,0.1c0,0,0,0.1-0.1,0.1l-0.9,0.5c0,0-0.1,0-0.1,0 c0,0,0-0.1,0-0.1l0.2-3.1c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.1l2.3-1.4c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1v0.9 c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1l-1.6,0.9v0.8c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.3,0,0.5,0.1 c0.1,0.1,0.3,0.3,0.3,0.4c0.1,0.3,0.1,0.5,0.1,0.8c0,0.3,0,0.7-0.1,1c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.3-0.3,0.5-0.5,0.7 c-0.2,0.2-0.4,0.4-0.6,0.5c-0.2,0.1-0.4,0.2-0.7,0.2c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.3-0.2-0.3-0.4c-0.1-0.2-0.1-0.4-0.1-0.6 c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1l0.7-0.4C185.3,365.7,185.4,365.7,185.4,365.7C185.4,365.7,185.4,365.7,185.4,365.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_575",
    className: "st16",
    d: "M206,346.2c-0.3-0.1-0.5-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9V348c0-0.3-0.1-0.6-0.3-0.7L206,346.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_576",
    className: "st17",
    d: "M194.7,361.9l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.5-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C194.3,361.4,194.4,361.7,194.7,361.9L194.7,361.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_577",
    className: "st13",
    d: "M196.2,354.9v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9V348 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C196.7,353.4,196.3,354.1,196.2,354.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_578",
    className: "st5",
    d: "M203.9,354.8c0,0.3,0,0.7-0.1,1c-0.1,0.3-0.2,0.6-0.4,0.9c-0.1,0.3-0.3,0.5-0.5,0.7 c-0.2,0.2-0.4,0.4-0.6,0.5c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4,0-0.5-0.1c-0.2-0.1-0.3-0.3-0.4-0.5c-0.1-0.3-0.1-0.5-0.1-0.8 c0-0.2,0-0.3,0-0.5c0-0.2,0-0.3,0.1-0.5c0-0.1,0.1-0.3,0.1-0.4s0.1-0.3,0.1-0.4l1-2.8l0.1-0.1c0-0.1,0.1-0.1,0.1-0.1l0.9-0.5 h0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0l-0.7,1.9c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.3,0.1,0.4,0.2 c0.1,0.1,0.2,0.3,0.3,0.5C203.8,354.3,203.9,354.5,203.9,354.8L203.9,354.8z M201.6,356.1c0,0.1,0,0.2,0.1,0.3 c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.3 c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.4c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.3 C201.7,355.8,201.6,356,201.6,356.1L201.6,356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_579",
    className: "st16",
    d: "M173.6,381.2c-0.3-0.1-0.5-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9V383c0-0.3-0.1-0.6-0.3-0.7L173.6,381.2z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_580",
    className: "st17",
    d: "M162.3,396.8l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.5-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C161.9,396.4,162,396.7,162.3,396.8L162.3,396.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_581",
    className: "st13",
    d: "M163.8,389.9v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9V383 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C164.3,388.4,163.9,389.1,163.8,389.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_582",
    className: "st5",
    d: "M168.9,393.1c0,0,0-0.1,0-0.1l1.2-4.9l-1.6,1c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-0.9 c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1l2.6-1.5c0,0,0.1,0,0.1,0v0.9c0,0.2,0,0.3-0.1,0.5l-1.1,4.9l-0.1,0.2 c0,0.1-0.1,0.1-0.1,0.1l-0.8,0.4c0,0-0.1,0-0.1,0c0,0,0,0,0,0C169,393.1,169,393.1,168.9,393.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_583",
    className: "st16",
    d: "M189.8,371.8c-0.3-0.1-0.6-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1.1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.9v-7.4c0-0.3-0.1-0.5-0.3-0.7 L189.8,371.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_584",
    className: "st17",
    d: "M178.5,387.5l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.4-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C178.1,387.1,178.2,387.3,178.5,387.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_585",
    className: "st13",
    d: "M180,380.5v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.9v-7.4 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C180.5,379,180.1,379.8,180,380.5L180,380.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_586",
    className: "st5",
    d: "M184.5,380.2c0-0.3,0-0.6,0.1-0.8c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.2,0.3-0.5,0.5-0.7 c0.2-0.2,0.4-0.4,0.6-0.5c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.3,0.2,0.3,0.4c0.1,0.2,0.1,0.4,0.1,0.7 c0,0.2,0,0.4-0.1,0.7c0,0.2-0.1,0.4-0.2,0.6c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.2,0.1,0.4,0.1,0.6c0,0.3,0,0.6-0.1,0.8 c-0.2,0.5-0.5,1.1-0.9,1.5c-0.2,0.2-0.4,0.4-0.6,0.5c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4,0-0.5-0.1c-0.2-0.1-0.3-0.2-0.3-0.4 c-0.1-0.2-0.1-0.4-0.1-0.7c0-0.3,0-0.5,0.1-0.7c0.1-0.2,0.1-0.5,0.3-0.7c-0.1-0.1-0.2-0.2-0.2-0.4 C184.5,380.5,184.5,380.3,184.5,380.2z M185.4,382c0,0.1,0,0.3,0.1,0.3c0.2,0,0.3,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.4 c0.1-0.1,0.2-0.3,0.2-0.5c0-0.1,0-0.3-0.2-0.3c-0.1,0-0.2,0-0.4,0.1c-0.2,0.1-0.3,0.2-0.5,0.4 C185.5,381.6,185.4,381.8,185.4,382L185.4,382z M185.5,379.6c0,0.1,0,0.3,0.1,0.3c0.1,0.1,0.2,0,0.4-0.1 c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.1,0.1-0.3,0.1-0.5c0-0.2,0-0.3-0.1-0.3s-0.2,0-0.4,0.1C185.7,378.9,185.5,379.2,185.5,379.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_587",
    className: "st16",
    d: "M206,362.5c-0.3-0.1-0.5-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9v-7.4c0-0.3-0.1-0.6-0.3-0.7L206,362.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_588",
    className: "st17",
    d: "M194.7,378.1l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.5-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C194.3,377.7,194.4,378,194.7,378.1L194.7,378.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_589",
    className: "st13",
    d: "M196.2,371.2v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9v-7.4 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C196.7,369.7,196.3,370.4,196.2,371.2L196.2,371.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_590",
    className: "st5",
    d: "M200.6,371.1c0-0.3,0-0.7,0.1-1c0.1-0.3,0.2-0.6,0.4-0.9c0.1-0.3,0.3-0.5,0.5-0.7 c0.2-0.2,0.4-0.4,0.6-0.5c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.3,0.1,0.5,0.1,0.8 c0,0.2,0,0.3,0,0.5c0,0.2,0,0.3-0.1,0.5c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.3-0.1,0.4l-1,2.8c0,0,0,0.1-0.1,0.1 c0,0.1-0.1,0.1-0.1,0.1l-0.9,0.5c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1v0l0.7-1.9c-0.2,0.1-0.3,0.1-0.5,0.1 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.3-0.5C200.7,371.6,200.6,371.3,200.6,371.1L200.6,371.1z M202.8,369.8 c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.2,0.1-0.2,0.2 c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2 c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.1-0.3 C202.8,370,202.8,369.9,202.8,369.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_591",
    className: "st16",
    d: "M222.2,336.8c-0.3-0.1-0.5-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.9v-7.4c0-0.3-0.1-0.5-0.3-0.7 L222.2,336.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_592",
    className: "st17",
    d: "M210.9,352.5l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.5-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C210.5,352.1,210.6,352.3,210.9,352.5L210.9,352.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_593",
    className: "st13",
    d: "M212.4,345.5v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.9v-7.4 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C212.9,344.1,212.5,344.8,212.4,345.5L212.4,345.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_594",
    className: "st5",
    d: "M218,342.8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v0.9c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1 l-1.6,1v1.1l1.5-0.9c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v0.8c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1l-1.5,0.9v1.8 c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1l-0.7,0.4c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-5.4c0-0.1,0-0.1,0-0.2 c0-0.1,0.1-0.1,0.1-0.1L218,342.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_595",
    className: "st5",
    d: "M221.6,342.6c0,0.2,0,0.3,0,0.5c0,0.2-0.1,0.3-0.1,0.5c-0.1,0.2-0.1,0.4-0.2,0.5 c-0.1,0.2-0.2,0.4-0.3,0.6l-0.8,1.3l1.4-0.8h0.1c0,0,0,0.1,0,0.1v0.9c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1l-2.9,1.7 c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1v-0.7c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.3l1.6-2.7c0.1-0.2,0.2-0.3,0.2-0.5 c0-0.1,0-0.3,0-0.4V343c0-0.1,0-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.2,0.1-0.2,0.2 c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.2v0.2c0,0.1,0,0.1-0.1,0.2l-0.1,0.1l-0.7,0.4c0,0-0.1,0-0.1,0c0,0,0,0,0,0 c0,0,0-0.1,0-0.1c0-0.3,0-0.5,0.1-0.8c0.1-0.6,0.4-1.1,0.8-1.5c0.2-0.2,0.4-0.4,0.7-0.6c0.2-0.1,0.4-0.2,0.6-0.2 c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.3,0.5C221.6,342.1,221.6,342.3,221.6,342.6L221.6,342.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_596",
    className: "st16",
    d: "M222.2,353.1c-0.3-0.1-0.5-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.7-0.4,1.1-1.1,1.1-1.9v-7.4c0-0.3-0.1-0.5-0.3-0.7 L222.2,353.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_597",
    className: "st17",
    d: "M210.9,368.8l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.5-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C210.5,368.4,210.6,368.6,210.9,368.8L210.9,368.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_598",
    className: "st13",
    d: "M212.4,361.8v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.7-0.4,1.1-1.1,1.1-1.9v-7.4 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C212.9,360.4,212.5,361.1,212.4,361.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_599",
    className: "st5",
    d: "M217.9,359.1c0,0,0.1,0,0.1,0v1c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1l-1.6,1v1.1 l1.5-0.9c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v0.9c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1l-1.5,0.9v1.8c0,0.1,0,0.1,0,0.2 c0,0.1-0.1,0.1-0.1,0.1l-0.7,0.4h-0.1c0,0,0-0.1,0-0.1v-5.5c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1L217.9,359.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_600",
    className: "st5",
    d: "M221.4,357.1c0,0,0.1,0,0.1,0v1c0,0.1,0,0.1,0,0.2l-0.1,0.2l-0.7,1.4 c0.2-0.1,0.5,0,0.7,0.2c0.2,0.2,0.3,0.6,0.3,0.9c0,1.2-0.6,2.3-1.6,2.9c-0.2,0.1-0.5,0.2-0.7,0.3c-0.2,0-0.4,0-0.5-0.1 c-0.1-0.1-0.3-0.2-0.3-0.4c-0.1-0.2-0.1-0.4-0.1-0.5c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1l0.7-0.4c0.1,0,0.1,0,0.2,0l0.1,0.1 c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.3 c-0.2,0-0.3,0-0.4,0.1l-0.5,0.3h-0.1c0,0,0-0.1,0-0.1v-0.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0.1-0.2l0.6-1.2l-1.4,0.8 c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-0.9c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1L221.4,357.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_601",
    className: "st16",
    d: "M173.6,397.5c-0.3-0.1-0.5-0.1-0.8,0.1l-9.8,5.7c-0.6,0.4-1.1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7c0.2,0.1,1.7,1,1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9v-7.3 c0-0.3-0.1-0.5-0.3-0.7L173.6,397.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_602",
    className: "st17",
    d: "M162.3,413.2c0.2,0.1,1.7,1,1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.5-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C161.9,412.7,162,413,162.3,413.2L162.3,413.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_603",
    className: "st13",
    d: "M163.8,406.2v7.3c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1-1.1,1.1-1.9v-7.3 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C164.3,404.8,163.9,405.5,163.8,406.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_604",
    className: "st5",
    d: "M170.1,405.9l0.4-0.6l0,0c0,0,0.1,0,0.1,0s0,0,0.1,0.1l0.2,0.7c0,0,0,0.1,0,0.1 c0,0.1,0,0.1-0.1,0.1l0,0l-0.4,0.3l0.4,0.2l0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1l-0.4,0.8c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0 v0l-0.2-0.6l-0.2,0.8v0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0l-0.4-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1l0,0v-0.1l0.4-0.6 l-0.5,0.2l0,0l-0.1-0.1c0,0,0-0.1,0-0.1l0.2-0.9c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1l0,0l0.4,0.2l-0.1-0.6v-0.1 c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1l0.6-0.3c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1L170.1,405.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_605",
    className: "st16",
    d: "M189.8,388.1c-0.3-0.1-0.6-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1.1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.8V390c0-0.3-0.1-0.6-0.3-0.7 L189.8,388.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_606",
    className: "st17",
    d: "M178.5,403.8l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.4-4.3l-10.1-5.8 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C178.1,403.4,178.2,403.7,178.5,403.8L178.5,403.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_607",
    className: "st13",
    d: "M180,396.9v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.8V390 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C180.5,395.4,180.1,396.1,180,396.9L180,396.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_608",
    className: "st5",
    d: "M186,393.8c0.2-0.1,0.5-0.2,0.7-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.2,0.2,0.4,0.3,0.6 c0.1,0.3,0.1,0.5,0.1,0.8v1.5c0,0.3-0.1,0.6-0.1,0.9c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.3-0.3,0.5-0.5,0.8 c-0.2,0.2-0.4,0.4-0.7,0.6c-0.2,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.3-0.1-0.5-0.1-0.8 V397c0-0.3,0-0.6,0.1-0.9c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.3-0.5,0.5-0.8C185.5,394.1,185.8,393.9,186,393.8z M186.6,397.2 v-1.4c0-0.1,0-0.2,0-0.4c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0.1c-0.2,0.1-0.4,0.3-0.4,0.5 c0,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.3,0,0.4v1.4c0,0.1,0,0.2,0,0.4c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.2,0.1 c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.4 C186.6,397.4,186.6,397.3,186.6,397.2L186.6,397.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_609",
    className: "st16",
    d: "M206,378.8c-0.3-0.1-0.5-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.9v-7.4c0-0.3-0.1-0.5-0.3-0.7L206,378.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_610",
    className: "st17",
    d: "M194.7,394.5l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.5-4.3l-10.1-5.8 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C194.3,394,194.4,394.3,194.7,394.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_611",
    className: "st13",
    d: "M196.2,387.5v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.9v-7.4 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C196.7,386,196.3,386.7,196.2,387.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_612",
    className: "st5",
    d: "M203.4,385.1l0.3-0.2h0.1c0,0,0.1,0.1,0.1,0.1v0.8c0,0.1,0,0.1-0.1,0.2 c0,0.1-0.1,0.1-0.1,0.1l-0.4,0.2l-0.1,0.9l0.4-0.2c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1v0.8c0,0.1,0,0.1-0.1,0.2 c0,0-0.1,0.1-0.1,0.1l-0.5,0.3l-0.1,0.8c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1l-0.6,0.3c0,0,0,0-0.1,0c0,0,0,0,0,0 c0,0,0-0.1,0-0.1l0,0l0.1-0.7l-0.4,0.2l-0.1,0.8c0,0,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1l-0.6,0.3c0,0,0,0-0.1,0c0,0,0,0,0,0 c0,0,0-0.1,0-0.1l0,0l0.1-0.7l-0.3,0.2c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1v-0.8c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.1 l0.4-0.2l0.1-0.9l-0.4,0.2c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1v-0.8c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.1l0.5-0.3 l0.1-0.8c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1l0.6-0.3h0.1c0,0,0,0.1,0,0.1l0,0l-0.1,0.7l0.4-0.2l0.1-0.8c0-0.1,0-0.1,0.1-0.1 c0,0,0-0.1,0.1-0.1l0.6-0.3c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1l0,0L203.4,385.1z M202,388.1l0.4-0.2l0.1-0.9l-0.4,0.2 L202,388.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_613",
    className: "st16",
    d: "M222.2,369.4c-0.3-0.1-0.5-0.1-0.8,0.1l-9.8,5.6c-0.6,0.4-1.1,1.1-1.1,1.9v7.4 c0,0.3,0.1,0.5,0.3,0.7l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.9v-7.4c0-0.3-0.1-0.5-0.3-0.7 L222.2,369.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_614",
    className: "st17",
    d: "M210.9,385.1l1.9,1.1c0.3,0.1,0.6,0.1,0.8-0.1l7.5-4.3l-10.1-5.9 c-0.2,0.3-0.3,0.7-0.3,1.1v7.4C210.5,384.7,210.6,384.9,210.9,385.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_615",
    className: "st13",
    d: "M212.4,378.2v7.4c0,0.7,0.5,1,1.1,0.6l9.8-5.6c0.6-0.4,1.1-1.1,1.1-1.9v-7.4 c0-0.7-0.5-1-1.1-0.6l-9.8,5.6C212.9,376.7,212.5,377.4,212.4,378.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_616",
    className: "st5",
    d: "M217.9,375.5c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v0.9c0,0.1,0,0.1,0,0.2 c0,0.1-0.1,0.1-0.1,0.1l-1.6,1v1.1l1.5-0.9h0.1c0,0,0.1,0.1,0.1,0.1v0.9c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.1l-1.5,0.9 v1.8c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1l-0.7,0.4c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1v-5.4c0-0.1,0-0.1,0.1-0.2 c0-0.1,0.1-0.1,0.1-0.1L217.9,375.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_617",
    className: "st5",
    d: "M220.4,379.9c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-0.9l-1.7,1c0,0-0.1,0-0.1,0 c0,0,0-0.1,0-0.1v-0.9c0-0.1,0-0.3,0.1-0.4l1.5-4.1c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0.1-0.1l0.8-0.5c0,0,0.1,0,0.1,0 c0,0,0.1,0.1,0.1,0.1v3.2l0.5-0.3c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1v0.9c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.1l-0.5,0.3 v0.9c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1L220.4,379.9z M220.3,377.5V376l-0.8,2L220.3,377.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_618",
    className: "st3",
    d: "M152.2,297.8v138.1c0,14.7-10.3,20.6-23,13.3L115,441c-2.3-1.5-3.7-3.9-3.9-6.6V251.9 c0-2.4,1.7-3.4,3.8-2.2l14.2,8.2C141.9,265.2,152.2,283.1,152.2,297.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_619",
    className: "st4",
    d: "M139.4,442.6c-2.1-0.1-4.1-0.8-5.8-2l-12.2-7c-0.9-0.5-1.4-1.4-1.4-2.4V269.5 c0-1.5,1.2-2.8,2.8-2.8c0.5,0,1,0.1,1.4,0.4c10.5,6.1,19.1,19.2,19.1,31.3V435c0,2.9-0.6,5.3-1.6,6.6 C141.2,442.3,140.3,442.7,139.4,442.6z M123.6,430.7l11.8,6.8c1.2,0.7,2.4,1.2,3.8,1.5c0.5-1.3,0.7-2.6,0.6-4V298.4 c0-10.4-7.3-21.7-16.2-27.6L123.6,430.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_620",
    className: "st8",
    d: "M114.7,253.6l12.7,7.3c11.7,6.8,21.3,23.3,21.3,36.8v138.1c0,8.1-3.4,12.9-9.2,12.9 c-3-0.1-6-1.1-8.5-2.7l-14.2-8.2c-1.2-0.8-1.9-2.1-2.1-3.6V253.6 M113.3,249.2c-1.3,0-2.1,1-2.1,2.8v182.4 c0.2,2.7,1.6,5.2,3.9,6.6l14.2,8.2c3.1,1.9,6.6,3,10.2,3.2c7.6,0,12.8-6,12.8-16.5V297.8c0-14.7-10.3-32.5-23-39.9l-14.2-8.2 C114.5,249.4,113.9,249.2,113.3,249.2L113.3,249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_621",
    className: "st18",
    d: "M114.7,253.6l12.7,7.3c11.7,6.8,21.3,23.3,21.3,36.8v138.1c0,8.1-3.4,12.9-9.2,12.9 c-3-0.1-6-1.1-8.5-2.7l-14.2-8.2c-1.2-0.8-1.9-2.1-2.1-3.6V253.6 M113.3,249.2c-1.3,0-2.1,1-2.1,2.8v182.4 c0.2,2.7,1.6,5.2,3.9,6.6l14.2,8.2c3.1,1.9,6.6,3,10.2,3.2c7.6,0,12.8-6,12.8-16.5V297.8c0-14.7-10.3-32.5-23-39.9l-14.2-8.2 C114.5,249.4,113.9,249.2,113.3,249.2L113.3,249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_622",
    className: "st3",
    d: "M240.7,367.6c-1.2,0-2.4-0.3-3.4-0.9c-2.5-1.4-3.8-4.4-3.8-8.2v-89.8 c0-7.6,5.4-16.9,12-20.7l34.6-20c3.4-1.9,6.6-2.2,9-0.8s3.8,4.3,3.8,8.2v89.8c0,7.6-5.4,16.9-12,20.7l-34.6,20 C244.6,367,242.6,367.6,240.7,367.6z M285.5,228.1c-1.7,0.1-3.3,0.6-4.7,1.5l-34.6,20c-6.1,3.5-11.1,12.1-11.1,19.2v89.8 c0,3.2,1,5.6,2.9,6.7s4.5,0.8,7.2-0.8l34.6-20c6.1-3.5,11.1-12.1,11.1-19.2v-89.8c0-3.2-1-5.6-2.9-6.7 C287.3,228.3,286.4,228.1,285.5,228.1L285.5,228.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_623",
    className: "st16",
    d: "M263.8,272.9c-3.1,1.8-5.5,6.2-6.8,10.9c-0.3,1-0.1,1.7,0.4,2l0,0c0.6,0.4,1.5,0.2,2-1 c1.2-3.3,2.5-6.9,4.6-8.4c2.2-1.6,4.1-1.4,5.1,1.3c0.3,0.8,1.2,1,1.8,0l0,0c0.4-0.7,0.5-1.6,0.2-2.3 C269.5,272.2,266.8,271.1,263.8,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_624",
    className: "st16",
    d: "M262.8,265.5c-4.6,2.6-8.6,8.7-10.9,15.5c-0.3,1-0.2,2,0.2,2.4l0,0c0.6,0.4,1.6,0,2-1.1 c1.9-5.6,4.9-10.9,8.7-13.1c3.7-2.2,7-1.1,8.9,2.4c0.4,0.7,1.2,0.5,1.8-0.5l0,0c0.5-0.8,0.6-1.8,0.3-2.6 C271.4,264.2,267.4,262.9,262.8,265.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_625",
    className: "st16",
    d: "M277.6,263c-0.1,0.4-0.3,0.7-0.4,1c-0.6,1-1.4,1.2-1.8,0.5c-1.2-2.3-3.3-3.9-5.8-4.5 c-6.6-1.2-15.2,6.4-19.4,18.1l-0.2,0.6c-0.4,1.1-0.9,1.8-1.9,1.5s-0.9-1.6-0.5-2.7l0.2-0.7c5-13.8,15.3-22.4,23-21 c2.9,0.6,5.4,2.6,6.8,5.2C277.7,261.6,277.8,262.3,277.6,263L277.6,263z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_626",
    className: "st13",
    d: "M256,297.7v1.4c0,0.1,0,0.2,0,0.4c0,0.1,0,0.3,0.1,0.4c0,0.1,0.1,0.2,0.1,0.3 c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.3-0.1,0.4-0.1c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.1-0.3 c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2l0.9-0.5c0,0,0.1,0,0.1,0v0.1c0,0.4-0.1,0.7-0.2,1.1 c-0.1,0.4-0.2,0.7-0.4,1c-0.2,0.3-0.4,0.6-0.7,0.9c-0.2,0.3-0.5,0.5-0.8,0.7c-0.3,0.2-0.6,0.3-0.9,0.3c-0.2,0-0.5-0.1-0.6-0.2 c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1-0.3-0.2-0.7-0.2-1v-1.8c0-0.8,0.2-1.6,0.6-2.3c0.2-0.4,0.4-0.7,0.6-1c0.2-0.3,0.5-0.5,0.9-0.7 c0.2-0.2,0.5-0.2,0.8-0.3c0.2,0,0.5,0,0.7,0.2c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.3,0.2,0.6,0.2,0.9c0,0.1,0,0.1,0,0.2 c0,0-0.1,0.1-0.1,0.1l-0.9,0.5c-0.1,0-0.1,0-0.1,0c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2 c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.3-0.1,0.5 C256.1,297.3,256,297.5,256,297.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_627",
    className: "st13",
    d: "M262,291.5c0.1-0.1,0.1-0.1,0.2,0c0,0,0.1,0.1,0.1,0.2l1.4,5.6c0,0.1,0,0.2,0,0.3 c0,0-0.1,0.1-0.1,0.1l-0.8,0.5c-0.1,0-0.1,0.1-0.2,0c0,0-0.1-0.1-0.1-0.1l-0.2-0.7l-1.8,1l-0.2,1c0,0.1,0,0.1-0.1,0.2 c0,0.1-0.1,0.1-0.2,0.2l-0.8,0.5c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2l1.5-7.3c0-0.1,0.1-0.2,0.1-0.3 c0-0.1,0.1-0.2,0.2-0.2L262,291.5z M261,296.6l1.1-0.6l-0.5-2.1L261,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_628",
    className: "st13",
    d: "M266.3,289c0.2-0.2,0.5-0.3,0.8-0.3c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.3,0.3,0.4,0.5 c0.1,0.3,0.1,0.7,0.1,1c0,0.5-0.1,0.9-0.2,1.4c-0.1,0.4-0.3,0.8-0.6,1.1l0.8,2c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2 c0,0.1-0.1,0.1-0.1,0.1l-0.9,0.5c-0.1,0-0.1,0.1-0.2,0c0,0-0.1-0.1-0.1-0.1l-0.7-1.8l-0.6,0.4v2.2c0,0.1,0,0.2,0,0.2 c0,0.1-0.1,0.1-0.1,0.1l-0.9,0.5c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.2v-6.6c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.1,0.1-0.1 L266.3,289z M265.6,292.6l0.8-0.4c0.2-0.1,0.3-0.3,0.5-0.4c0.1-0.2,0.2-0.5,0.2-0.7c0-0.3-0.1-0.5-0.2-0.5c-0.2,0-0.3,0-0.5,0.1 l-0.8,0.4V292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_629",
    className: "st13",
    d: "M270.9,286.4c0.3-0.2,0.5-0.3,0.8-0.3c0.2,0,0.5,0.1,0.6,0.2c0.2,0.2,0.4,0.4,0.4,0.7 c0.1,0.3,0.2,0.7,0.2,1v1.4c0,0.4-0.1,0.8-0.2,1.3c-0.1,0.4-0.2,0.8-0.4,1.1c-0.2,0.4-0.4,0.7-0.6,1c-0.2,0.3-0.5,0.5-0.8,0.7 l-1.8,1c0,0-0.1,0-0.1,0c0-0.1,0-0.1,0-0.2v-6.6c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.2L270.9,286.4z M271.8,288.7 c0-0.8-0.3-1-0.9-0.7l-0.7,0.4v4l0.7-0.4c0.6-0.4,0.9-1,0.9-1.7c0-0.1,0-0.3,0-0.4v-0.7C271.8,289,271.8,288.8,271.8,288.7 L271.8,288.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_630",
    className: "st6",
    d: "M283.3,234.6c-2,1.3-3.2,3.4-3.3,5.8c0,2.1,1.5,3,3.3,1.9c2-1.3,3.2-3.4,3.4-5.8 C286.7,234.4,285.2,233.6,283.3,234.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLateral01);
export default __webpack_public_path__ + "static/media/Lateral01.82066269283dd5f34b30287465280ddf.svg";
export { ForwardRef as ReactComponent };